import { ReactComponent as TopDarkSVG } from "./top-bg.svg"

export default TopDarkSVG